// extracted by mini-css-extract-plugin
export default {"l_CalendarIcon_main":"CalendarIcon_l_CalendarIcon_main__9teoG","l_CalendarIcon_icon_img":"CalendarIcon_l_CalendarIcon_icon_img__h-SCj"};